var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoWorkphone = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "17px",
    viewBox: "0 0 18 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F194623A-DA0F-4D1A-BFB2-DFACE5BFDDE7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "06-profile-new-concept-scroll",
    transform: "translate(-142.000000, -615.000000)",
    fill: "#FF5000",
    stroke: "#FF5000",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "left",
    transform: "translate(100.000000, 171.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile-bx"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(20.000000, 298.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(23.000000, 147.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5,15 L3.5,15 C2.673,15 2,14.327 2,13.5 L2,12 C2,11.509 2.18,11.04 2.5,10.683 L2.5,4.317 C2.18,3.959 2,3.491 2,3 L2,1.5 C2,0.673 2.673,0 3.5,0 L5.5,0 C6.327,0 7,0.673 7,1.5 L7,3 C7,3.491 6.82,3.959 6.5,4.317 L6.5,10.682 C6.82,11.04 7,11.509 7,12 L7,13.5 C7,14.327 6.327,15 5.5,15 Z M3.5,1 C3.224,1 3,1.224 3,1.5 L3,3 C3,3.284 3.12,3.551 3.329,3.733 C3.438,3.828 3.5,3.965 3.5,4.11 L3.5,10.89 C3.5,11.035 3.438,11.172 3.329,11.267 C3.12,11.448 3,11.716 3,12 L3,13.5 C3,13.775 3.224,14 3.5,14 L5.5,14 C5.776,14 6,13.775 6,13.5 L6,12 C6,11.716 5.88,11.448 5.671,11.267 C5.562,11.172 5.5,11.034 5.5,10.89 L5.5,4.11 C5.5,3.965 5.562,3.828 5.671,3.733 C5.88,3.551 6,3.284 6,3 L6,1.5 C6,1.224 5.776,1 5.5,1 L3.5,1 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5,14 L1,14 C0.439,14 0,13.561 0,13 L0,2 C0,1.449 0.449,1 1,1 L2.5,1 C2.776,1 3,1.224 3,1.5 C3,1.776 2.776,2 2.5,2 L1,2 L1,13 L2.5,13 C2.776,13 3,13.224 3,13.5 C3,13.776 2.776,14 2.5,14 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,14 L6.5,14 C6.224,14 6,13.776 6,13.5 C6,13.224 6.224,13 6.5,13 L15,13 L15,2 L6.5,2 C6.224,2 6,1.776 6,1.5 C6,1.224 6.224,1 6.5,1 L15,1 C15.561,1 16,1.439 16,2 L16,13 C16,13.561 15.561,14 15,14 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5,6 L8.5,6 C8.224,6 8,5.776 8,5.5 L8,3.5 C8,3.224 8.224,3 8.5,3 L13.5,3 C13.776,3 14,3.224 14,3.5 L14,5.5 C14,5.776 13.776,6 13.5,6 Z M9,5 L13,5 L13,4 L9,4 L9,5 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 10.5,
    y: 9,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 10.5,
    y: 7,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 10.5,
    y: 11,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 8,
    y: 9,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 8,
    y: 7,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 8,
    y: 11,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 13,
    y: 9,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 13,
    y: 7,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 13,
    y: 11,
    width: 1,
    height: 1
  })))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoWorkphone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_workphone.00cd5dd5ac8a2fcd735f05235102cdb1.svg";